import { useEffect, useRef } from 'react';
import { EFFECT_VALUE_CSS_OFFSET } from 'constants/params';

export type CssFilter = {
  brightness: number;
  contrast: number;
};

export const useCssFilter = ({ brightness, contrast }: CssFilter) => {
  const domElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    domElement?.current?.style.setProperty(
      'filter',
      `
        brightness(${brightness + EFFECT_VALUE_CSS_OFFSET}%)
        contrast(${contrast + EFFECT_VALUE_CSS_OFFSET}%)
      `
    );
  }, [brightness, contrast]);

  return domElement;
};
